/* GHALIA — preserve native network APIs before third-party ScriptTags; block known malware injectors. */
(function () {
  if (window.__GhaliaNet) return;
  var nativeFetch = window.fetch && window.fetch.bind(window);
  var NativeXHR = window.XMLHttpRequest;
  window.__GhaliaNet = { fetch: nativeFetch, XHR: NativeXHR };

  var badScript = /yunmuqing|eHiCrt3bAmCw3EHk|rev_89659212146/i;
  var stripBadScript = function (node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'SCRIPT') {
      var src = node.src || node.getAttribute('src') || '';
      if (badScript.test(src)) node.remove();
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('script[src]').forEach(function (s) {
        if (badScript.test(s.src || '')) s.remove();
      });
    }
  };

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(stripBadScript);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('script[src]').forEach(stripBadScript);
  });
})();
